import React from 'react';

import {
    Link,
} from '@material-ui/core';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyButton from '../AuthBodyButton';
import AuthBodyContent from '../AuthBodyContent';

const CONTACT_US_URL = "https://www.landhawk.uk/contact/";

function ExpiredBody () {
    return (
        <AuthBody error>
            <AuthBodyTitle>
                Subscription expired
            </AuthBodyTitle>
            <AuthBodyContent>
                Sorry your subscription has now expired.
                <br />
                <br />
                If this is unexpected, please contact a member of our customer 
                support team who will be happy to investigate and resolve the issue.
            </AuthBodyContent>
            <Link href={CONTACT_US_URL} target="_blank">
                <AuthBodyButton>
                    Contact the team
                </AuthBodyButton>
            </Link>     
        </AuthBody>
    );
}

export default ExpiredBody;